/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiRequestOptions } from "./ApiRequestOptions";

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

interface IIdentityObject {
  access_token: string;
  expires_at: number;
  id_token: string;
  profile: Object & { MolsonPrice: string; preferred_username: string };
  scope: string;
  session_state: string;
  token_type: string;
}

export const getAccessTokenFromLocalStorage = () => {
  const identityString = sessionStorage.getItem(
    "oidc.user:" +
      import.meta.env['NX_AUTHORITY'] +
      ":" +
      import.meta.env['NX_CLIENT_ID']
  );
  if (!identityString) {
    return undefined;
  }
  const identityObject: IIdentityObject = JSON.parse(identityString);
  return identityObject.access_token;
};

export const getAuthUserProfile = () => {
  const identityString = sessionStorage.getItem(
    "oidc.user:" +
      import.meta.env['NX_AUTHORITY'] +
      ":" +
      import.meta.env['NX_CLIENT_ID']
  );
  if (!identityString) {
    return undefined;
  }
  const identityObject: IIdentityObject = JSON.parse(identityString);
  return identityObject.profile;
};

export type OpenAPIConfig = {
  BASE: string;
  VERSION: string;
  WITH_CREDENTIALS: boolean;
  CREDENTIALS: "include" | "omit" | "same-origin";
  TOKEN?: string | Resolver<string>;
  USERNAME?: string | Resolver<string>;
  PASSWORD?: string | Resolver<string>;
  HEADERS?: Headers | Resolver<Headers>;
  ENCODE_PATH?: (path: string) => string;
};

export const OpenAPI: OpenAPIConfig = {
  BASE: import.meta.env['NX_API_BASE_PATH'] + "/users",
  VERSION: "1.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: getAccessTokenFromLocalStorage(),
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: {
    Accept: "application/json",
  },
  ENCODE_PATH: undefined,
};
